import { iso8601DurationToDays } from 'shared/lib/dates/iso8601DurationToDays';

/**
 * ISO 8601 DURATION в количество месяцев
 * @example "P5Y" => 60
 * По умолчанию 360 дней, чтобы при передаче любого количества лет отсутствовал некорректный остаток
 * Для дней округляем в большую сторону
 */
export const iso8601DurationToMonths = (isoDuration: string, { daysInMonth = 30, daysInYears = 360 } = {}): number => {
  try {
    return Math.ceil(iso8601DurationToDays(isoDuration, { daysInMonth, daysInYears }) / daysInMonth);
  } catch {
    return 0;
  }
};
